/* eslint-disable import/no-dynamic-require,  global-require */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';

import { eventTypes, trackEvent } from '../../../helpers/AnalyticsManager';
import PublicationLink from '../../../images/publications/publication-link.png';
import ToAppear from '../../../images/publications/to-appear.png';
import Placeholder from '../../../images/publications/images/placeholder.jpeg';

import './PublicationCell.css';

class PublicationCell extends Component {
  constructor() {
    super();
    this.state = {
      bibtexOpen: false,
    };

    document.addEventListener('click', () => {
      this.setState({
        bibtexOpen: false,
      });
    });
  }

  renderLink(element) {
    const { publication: { link, title } } = this.props;

    if (link) {
      return (
        <a
          className="myContent"
          href={link}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => {
            trackEvent(eventTypes.publicationLink, { label: title });
            return true;
          }}
        >
          {element}
        </a>
      );
    }

    return (element);
  }

  render() {
    const { publication } = this.props;
    const {
      image, title, forum, authors, link, bibtex,
    } = publication;

    const { bibtexOpen } = this.state;

    return (
      <div className="publicationCell">
        <div className="publicationImage">
          {this.renderLink(<img
            src={image}
            alt={title}
            onError={(event) => {
            /* eslint-disable-next-line no-param-reassign */
              event.target.src = Placeholder;
            }}
          />)}
        </div>

        <div className="publicationInfo">
          {this.renderLink(<h1>{title}</h1>)}
          <h2>{forum}</h2>
          { bibtex && (
            <div className="bibtex-container">
              { !bibtexOpen && (
                <p>
                  [
                  <button
                    type="button"
                    onClick={(e) => {
                      e.stopPropagation();
                      e.nativeEvent.stopImmediatePropagation();

                      this.setState({ bibtexOpen: true });
                    }}
                  >
                    BibTex
                  </button>
                  ]
                </p>
              )}
              { bibtexOpen && (
                <textarea
                  defaultValue={bibtex}
                  className="bibtex-text"
                  onClick={(e) => {
                    e.stopPropagation();
                    e.nativeEvent.stopImmediatePropagation();

                    const textarea = e.target;
                    textarea.focus();
                    textarea.select();
                    document.execCommand('Copy');
                  }}
                />
              )}
            </div>
          )}
          <p>{authors}</p>
        </div>

        <MediaQuery query="(min-width: 425px)">
          <div className="publicationLink">
            { this.renderLink(<img src={link ? PublicationLink : ToAppear} alt="Open paper icon" />) }
          </div>
        </MediaQuery>
      </div>
    );
  }
}

PublicationCell.propTypes = {
  publication: PropTypes.shape({
    image: PropTypes.string,
    title: PropTypes.string.isRequired,
    forum: PropTypes.string.isRequired,
    authors: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
  }).isRequired,
};

// PublicationCell.defaultProps = {
//   Image: '', // TODO: Add placeholder image
// };

export default PublicationCell;
